export const syncDateFormat = (date) => {
  let options = {
    hour: '2-digit',
    minute: '2-digit',
  };
  return `${new Date(date).toLocaleTimeString('en-us', options)} ${new Date(
    date
  ).toLocaleDateString('en-US')}`;
};
